// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for WModulo103

// Calculate code for Weighted Modulo 103
function ccd_ConvMod103Code(strCode, chrMode) {
  var intNum, intCharCode;

  if (strCode.length > 1) strCode = strCode.toUpperCase();

  // Check for common codes
  if (strCode == "START-A") return 103;
  else if (strCode == "START-B") return 104;
  else if (strCode == "START-C") return 105;
  else if (strCode == "FNC1") return 102;

  // Check for rest of 'C' mode characters
  if (chrMode == "C") {
    if (strCode == "CODE-A") return 101;
    else if (strCode == "CODE-B") return 100;
    else {
      // The code is the value in the string
      intNum = Number(strCode);

      if (isNaN(intNum)) return -1;
      else return Number(strCode);
    }
  }

  // Check single character strings
  if (strCode.length == 1) {
    intCharCode = strCode.charCodeAt(0);
    // Check fields common to A and B

    if (intCharCode >= "!".charCodeAt(0) && intCharCode <= "_".charCodeAt(0))
      return intCharCode - "!".charCodeAt(0) + 1;
    else if (
      chrMode == "B" &&
      intCharCode >= "`".charCodeAt(0) &&
      intCharCode <= "~".charCodeAt(0)
    )
      return intCharCode - "!".charCodeAt(0) + 1;
    else return -1;
  }

  // Check common strings
  if (strCode == "SP") return 0;
  else if (strCode == "FNC3") return 96;
  else if (strCode == "FNC2") return 97;
  else if (strCode == "SHIFT") return 98;
  else if (strCode == "CODE-C") return 99;

  if (chrMode == "A") {
    if (strCode == "NUL") return 64;
    else if (strCode == "SOH") return 65;
    else if (strCode == "STX") return 66;
    else if (strCode == "ETX") return 67;
    else if (strCode == "EOT") return 68;
    else if (strCode == "ENQ") return 69;
    else if (strCode == "ACK") return 70;
    else if (strCode == "BEL") return 71;
    else if (strCode == "BS") return 72;
    else if (strCode == "HT") return 73;
    else if (strCode == "LF") return 74;
    else if (strCode == "VT") return 75;
    else if (strCode == "FF") return 76;
    else if (strCode == "CR") return 77;
    else if (strCode == "SO") return 78;
    else if (strCode == "SI") return 79;
    else if (strCode == "DLE") return 80;
    else if (strCode == "DC1") return 81;
    else if (strCode == "DC2") return 82;
    else if (strCode == "DC3") return 83;
    else if (strCode == "DC4") return 84;
    else if (strCode == "NAK") return 85;
    else if (strCode == "SYN") return 86;
    else if (strCode == "ETB") return 87;
    else if (strCode == "CAN") return 88;
    else if (strCode == "EM") return 89;
    else if (strCode == "SUB") return 90;
    else if (strCode == "ESC") return 91;
    else if (strCode == "FS") return 92;
    else if (strCode == "GS") return 93;
    else if (strCode == "RS") return 94;
    else if (strCode == "US") return 95;
    else if (strCode == "CODE-B") return 100;
    else if (strCode == "FNC4") return 101;
  } else if (chrMode == "B") {
    if (strCode == "DEL") return 95;
    else if (strCode == "FNC4") return 100;
    else if (strCode == "CODE-A") return 101;
  }

  return -1;
}

function ccd_WModulo103(strCode) {
  var re,
    i,
    intTot,
    intLen,
    intCharCode,
    astrCodes,
    strCurrCode,
    chrCheck,
    chrMode;

  astrCodes = strCode.split(",");

  // Strip front and trailing spaces
  re = /\s+$/;
  strCurrCode = astrCodes[0].replace(re, "");
  re = /^\s+/;
  strCurrCode = strCurrCode.replace(re, "");
  re = /\s+/;
  strCurrCode = strCurrCode.replace(re, "-");

  chrMode = "A";
  intTot = ccd_ConvMod103Code(strCurrCode, chrMode);

  if (intTot == 104) chrMode = "B";
  else if (intTot == 105) chrMode = "C";
  else if (intTot != 103) return "ERROR:" + strCurrCode;

  intLen = astrCodes.length;

  for (i = 1; i < intLen; i++) {
    // Strip leading and trailing spaces
    re = /^ +/;
    strCurrCode = astrCodes[i].replace(re, "");
    re = / +$/;
    strCurrCode = strCurrCode.replace(re, "");
    re = / +/;
    strCurrCode = strCurrCode.replace(re, "-");

    intCharCode = ccd_ConvMod103Code(strCurrCode, chrMode);

    if (intCharCode == -1) return "ERROR:" + strCurrCode;

    intTot += i * intCharCode;

    if (intCharCode == 99) chrMode = "C";
    else if (intCharCode == 100) chrMode = "B";
    else if (intCharCode == 101) chrMode = "A";
  }

  intCharCode = intTot % 103;
  chrCheck = intCharCode.toString();

  return chrCheck;
}

export default ccd_WModulo103;
